import { render, staticRenderFns } from "./ProductsListAside.vue?vue&type=template&id=1bf294fe&scoped=true"
import script from "./ProductsListAside.vue?vue&type=script&lang=js"
export * from "./ProductsListAside.vue?vue&type=script&lang=js"
import style0 from "./ProductsListAside.vue?vue&type=style&index=0&id=1bf294fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf294fe",
  null
  
)

export default component.exports